import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MarkAsUnread = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 7h4.12L10.5 2 2 6.21V17h2V7.4L10.5 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8v13h17V8H5zm15 4-6.5 3.33L7 12v-2l6.5 3.33L20 10v2z"
  }));
});
MarkAsUnread.displayName = 'MarkAsUnread';
export var MarkAsUnreadDimensions = {
  height: 24,
  width: 24
};